import { v4 as uuidv4 } from 'uuid';
import { Account } from '../account/account';
import { BaseEntity } from '../baseEntity';
import { FormStatus } from './formStatus';
import { Rule } from './rule';
import { StepModel } from './step';

export interface FormContent {
  steps: Array<StepModel>;
  rules: Array<Rule>;
}

export interface DiscountModel {
  type: 'percent' | 'amount';
  value: number;
}

export interface Installment {
  date: string;
  percent: number;
}

export interface BaseMode {
  id: string;
  mode: string;
  discount: DiscountModel | null;
}

export type SingleMode =
  | BaseMode & {
      mode: 'single';
    };

export type FixedDatesMode =
  | BaseMode & {
      mode: 'fixed_dates';
      installments: Installment[];
    };

export type EmailContent = { emails: string[]; content: CultureTextModel[] | string };

export type PaymentMode = SingleMode | FixedDatesMode;

export type FormPaymentModes = { modes: PaymentMode[]; applyTo: string[] };

export type Discount = { type: 'percent' | 'amount'; value: number; code: string };

export type Coupon = { discountType: 'percent' | 'amount'; discountValue: number; code: string; discountTotal: number };

export type DiscountCode = { code: string; quantity: number; expirationDate: Date; discount: any };

export type CultureTextModel = { culture: string; value: string };

export interface FormModel extends BaseEntity {
  name: CultureTextModel[] | string;
  avatar: string | null;
  organizationId: string;
  editedBy: Account | undefined;
  submissionCount: number;
  submissionLimit: number | null;
  status: FormStatus;
  paymentEnabled?: boolean;
  paymentOptional?: boolean;
  fixedAmount?: number;
  paymentAccount?: string;
  paymentProvider?: string | null;
  content: FormContent;
  recaptchaEnabled: boolean;
  paymentModes?: FormPaymentModes | null;
  currency: 'usd' | 'cad';
  emailContent: EmailContent | null;
  discountCodes: DiscountCode[] | null;
  hasDiscountCodes: boolean;
  localizations: string[];
  fieldProperties: { properties?: any };
}

export class Form implements FormModel {
  public id: string;
  public avatar: string | null;
  public organizationId: string;
  public recaptchaEnabled: boolean;
  public name: string;
  public editedBy: Account | undefined;
  public submissionCount: number;
  public submissionLimit: number | null;
  public status: FormStatus;
  public creationDate: string;
  public modificationDate: string;
  public content: FormContent;
  public paymentEnabled: boolean;
  public paymentOptional: boolean;
  public fixedAmount: number;
  public paymentAccount: '';
  public paymentModes: FormPaymentModes | null;
  public currency: 'usd' | 'cad';
  public emailContent: EmailContent | null;
  public discountCodes: DiscountCode[] | null;
  public hasDiscountCodes: boolean;
  public paymentProvider: string | null;
  public localizations: string[];
  public fieldProperties: { properties?: any } = {};

  constructor(organization: string, name: string) {
    this.id = uuidv4();
    this.name = name;
    this.avatar = null;
    this.organizationId = organization;
    this.status = FormStatus.Pending;
    this.recaptchaEnabled = false;
    this.submissionCount = 0;
    this.creationDate = new Date().toISOString();
    this.modificationDate = new Date().toISOString();
    this.submissionLimit = null;
    this.paymentEnabled = false;
    this.paymentOptional = false;
    this.fixedAmount = 0;
    this.paymentAccount = '';
    this.currency = 'usd';
    this.content = {
      rules: [],
      steps: [],
    };
    this.paymentModes = null;
    this.emailContent = null;
    this.discountCodes = null;
    this.hasDiscountCodes = false;
    this.paymentProvider = null;
    this.localizations = [];
    this.fieldProperties = {};
  }
}
